import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9d61a362")

_pushScopeId("data-v-9d61a362")
const _hoisted_1 = {
  key: 0,
  "data-testid": "pickup-schedule-config-sidebar-skeleton",
  class: "w-full"
}
const _hoisted_2 = {
  key: 1,
  "data-testid": "pickup-schedule-config-sidebar-placeholder",
  class: "w-full flex flex-col py-3 px-4 bg-white rounded-xl card-border"
}
const _hoisted_3 = { class: "text-base font-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock("aside", _hoisted_1, [
        _createVNode(_component_Skeleton, {
          height: "160px",
          width: "100%",
          borderRadius: "12px"
        })
      ]))
    : (_openBlock(), _createBlock("aside", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("pickup.scheduleConfig.sidebar.addressTitle")) + " Dummy ", 1)
      ]))
})